<div class="col-12" *ngIf="!reportLoading">
  <table class="table">
    <tr>
      <th>Tên tài khoản</th>
      <th class="text-right">
        Số đơn
        <strong>(sum: {{data.totalOrders}})</strong>
      </th>
      <th class="text-right">
        Doanh Thu
        <strong>(sum: {{data.totalChargeCustomer | number:'1.1-2'}})</strong>
      </th>
      <th class="text-right">
        Tiền mua hàng
        <strong>(sum: {{data.totalFulfillCost | number:'1.1-2'}})</strong>
      </th>
      <th class="text-right">
        Lợi nhuận
        <strong>(sum: {{data.totalNetworth | number:'1.1-2'}})</strong>
      </th>
      <th class="text-right">%Lợi nhuận</th>
    </tr>
    <tr *ngFor="let acc of data.merchantNetworthReportItems">
      <td>{{acc.merchantName}}</td>
      <td class="text-right">{{acc.orderCount.toLocaleString('en-US')}}</td>
      <td class="text-right">{{acc.chargeCustomer.toLocaleString('en-US')}}</td>
      <td class="text-right">{{acc.fulfillCost.toLocaleString('en-US')}}</td>
      <td class="text-right">{{acc.netWorth.toLocaleString('en-US')}}</td>
      <td class="text-right">{{acc.netWorthPercentage.toLocaleString('en-US')}}%</td>
    </tr>
  </table>
</div>
<app-report-loading *ngIf="reportLoading"></app-report-loading>
